import React from 'react';
import { useRouter } from 'next/router';
import createLoginUrl from 'src/auth0/createLoginUrl';
import { paths } from 'src/utils/paths';

/**
 * 未ログイン状態に表示するフッター
 */
function LoggedOutFooter() {
  const router = useRouter();

  return (
    <div className="actions-footer">
      <div className="w-full flex box-border border-solid border-t border-gray fixed bottom-0 bg-white justify-evenly footer-wrapper">
        <div className="icons-margin">
          <label className="cursor-pointer" aria-label="さがすボタン">
            <img src={'/icons/footer-search-gray.svg'} alt="" />
            {/*「探す」は一旦Topに遷移させる仕様*/}
            {/*https://shiftus.slack.com/archives/C72PA4PPH/p1605697084317500*/}
            <input
              type="button"
              className="hidden"
              onClick={() => {
                router.push(`${paths.top}`);
              }}
            />
          </label>
        </div>
        <div className="icons-margin">
          <label className="cursor-pointer">
            <img src={'/icons/footer-login-gray.svg'} alt="" />
            <input
              type="button"
              className="hidden"
              onClick={() => {
                router.push(createLoginUrl(window.location.pathname));
              }}
            />
          </label>
        </div>
      </div>
      <style jsx>{`
        .actions-footer {
          height: var(--global-footer-height);
        }
        .icons-margin {
          margin: 10px 0 3px;
        }
        .footer-wrapper {
          padding-bottom: constant(safe-area-inset-bottom);
          padding-bottom: env(safe-area-inset-bottom);
        }
      `}</style>
    </div>
  );
}

export default LoggedOutFooter;
